module.exports = __webpack_public_path__ + "img/icon-67.38241266.svg";